import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://universidadmaderas.com/buniversity/index.php/'
});

export default instance;
